import { useApiPvpList } from "@/api/lctApIComponents";
import { useAppSelector } from "@/hooks/reduxHooks";
import { Loader2 } from "lucide-react";
import { DateTime } from "luxon";
import { Pvp } from "@/api/lctApISchemas";
import { ProgramTile } from "../ProgramTile";

interface IProps {
  onViewApplications?: (pvpId: string) => void;
}

export function PVP({ onViewApplications }: IProps) {
  const token = useAppSelector((state) => state.user.authKey);
  const { data, isLoading } = useApiPvpList({ headers: { Authorization: `Token ${token}` } });

  const renderProgram = (program: Pvp) => {
    if (!program.id) return null;

    const now = DateTime.now();
    const isApplicable = now > DateTime.fromISO(program.start_date) && now < DateTime.fromISO(program.end_date);
    return (
      <ProgramTile
        key={program.id}
        title={program.title}
        description={program.description ?? ""}
        isApplicable={isApplicable}
        programId={program.id ?? ""}
        lastUpdated={program.updated_at ?? ""}
        onViewApplications={onViewApplications}
      />
    );
  };

  return (
    <main className="h-full overflow-y-auto bg-slate-100 p-4">
      <div className="flex flex-row flex-wrap gap-6">
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        {!isLoading && data?.results.map(renderProgram)}
      </div>
    </main>
  );
}
